import { render, staticRenderFns } from "./Epitasis.vue?vue&type=template&id=1b89851c&"
import script from "./Epitasis.vue?vue&type=script&lang=js&"
export * from "./Epitasis.vue?vue&type=script&lang=js&"
import style0 from "./Epitasis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b89851c')) {
      api.createRecord('1b89851c', component.options)
    } else {
      api.reload('1b89851c', component.options)
    }
    module.hot.accept("./Epitasis.vue?vue&type=template&id=1b89851c&", function () {
      api.rerender('1b89851c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/Epitasis.vue"
export default component.exports